export const getContentType = () => ({
  'Content-Type': 'application/json',
})
